export type IParams = {
  id: string;
};

export enum EFleetDetailsTabs {
  DETAILS = 'details',
  NOTES = 'notes',
  PSP = 'psp',
  WARRANTY = 'warranty',
  MANUALS = 'manuals',
  EXPERTLINK = 'expertlink',
}
